import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { IOrderControlResult } from '../entities/IOrderControl';
import { OrderControlAdapter } from '../adapter/orderControlAdapter';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { OrderStatusFilterItemForOrderBusiness } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { IOrderControlRepository } from '@/coreInfrastructureModule/interfaces/IOrderControlRepository';

/**
 *  「発注管理情報」を取ってきてUI表示用に加工するUseCase
 */
export class GetOrderControlUseCase {
  private defaultPagingOptions: IPagingOptions = initPagingOptions(30);
  private repository: IOrderControlRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderControlRepository) {
    this.repository = repository;
  }

  /**
   *  TableDataをBusinessManagerから抽出する
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルタリングに使用する項目
   * @param orderStatusFilterItem - 発注ステータスのフィルタリングに使用する項目
   */
  public Execute = async (
    pagingOptions: IPagingOptions | undefined,
    sortKey: string | undefined,
    isAsc: boolean | undefined,
    filterItems: FilterContentItem[],
    orderStatusFilterItem: OrderStatusFilterItemForOrderBusiness = {
      Recommended: true,
      ApprovalRequested: true,
      ApprovedAwaitingDeliveryDate: true,
    }
  ): Promise<INetworkResult<IOrderControlResult, Error>> => {
    try {
      const usePagingOptions = pagingOptions || this.defaultPagingOptions;
      const [filterItem, filterInfoItem] = FilterService.convertFilterObjectWithInfo(filterItems);

      const result = await this.repository.get(
        isAsc ? 'ASC' : 'DESC',
        usePagingOptions.pageSize,
        usePagingOptions.offset,
        sortKey,
        filterItem,
        filterInfoItem,
        orderStatusFilterItem
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      const orderControlResult = OrderControlAdapter.adapt(result.status.data);

      return {
        status: {
          type: 'success',
          data: orderControlResult,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
